import { render, staticRenderFns } from "./BtnAtualizarCronogramaDesembolso.vue?vue&type=template&id=0bcb26a2"
import script from "./BtnAtualizarCronogramaDesembolso.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarCronogramaDesembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports